import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'src/components/EmptyListing/EmptyListing.scss';


const EmptyListing = ({
  image, imageType, header, hint, copy
}) => (
  <div styleName="empty-listing">

    <div styleName={ classNames('empty-listing__bitmap', {
      'empty-listing__bitmap__wide': imageType === 'wide',
      'empty-listing__bitmap__normal': imageType === 'normal'
    }) }
    >
      <img alt="" aria-hidden="true" src={ image } styleName="empty-listing__image" />
    </div>

    <div styleName="empty-listing__actions">

      <h3 styleName="empty-listing__header">
        {header}
      </h3>

      <p styleName="empty-listing__hint">
        {hint}
      </p>

      {copy}
    </div>
  </div>
);

EmptyListing.defaultProps = {
  imageType: 'normal'
};

EmptyListing.propTypes = {
  copy: PropTypes.node.isRequired,
  header: PropTypes.string.isRequired,
  hint: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageType: PropTypes.oneOf(['normal', 'wide'])
};


export default EmptyListing;
